export default __webpack_public_path__ + "static/gvi_people-276724b9cfef022acb28807dd214cea2.svg";